import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    const sound = new Audio("/confirm.mp3"); // Place in 'public/' folder
    sound.onended = () => navigate(path);
    sound.play();
  };

  return (
    <div className="card">
      <h1 className="title">SameBrain!</h1>
      <p className="subtitle">Do you think the same as your friends?</p>

      <div className="button-group">
        <button onClick={() => handleNavigation("/create")} className="button">
          Create game
        </button>
        <button onClick={() => handleNavigation("/join")} className="button">
          Join game
        </button>
      </div>

      <footer className="footer">
        <p>
          <strong>SameBrain!</strong> is a co-op two-player game with multiple rounds. In a round, both players type a word. If it's different, you play another round.
          If it's the same, the game ends. The goal is to converge on the same word in as few rounds as possible.
        </p>
      </footer>
    </div>
  );
};

export default Home;
